import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductListService } from '../product-list.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {

  public count: number;
  public products: Observable<any[]>;

  constructor(
    private productList: ProductListService
  ) {}

  ngOnInit() {
    this.products = this.productList.products.pipe(tap(result => this.count = result.length));
  }
}
